import React from 'react'
import { LazyLoadConfig } from './types'

interface PlaceholderProps extends LazyLoadConfig {
    className?: string
}

export const Placeholder = React.forwardRef<HTMLElement, PlaceholderProps>(
    ({ className, placeholder, placeholderWidth, placeholderHeight }, ref) => {
        if (placeholder) {
            return React.cloneElement(placeholder, {
                ref,
                className,
                style: {
                    height: placeholderHeight,
                    width: placeholderWidth,
                },
            })
        }

        // default to a <span> tag if no placeholder is specified
        return (
            <span
                className={className}
                ref={ref}
                style={{
                    display: 'inline-block',
                    height: placeholderHeight,
                    width: placeholderWidth,
                }}
            />
        )
    }
)
Placeholder.displayName = 'Placeholder'
